"use strict";

// Object.defineProperty(exports, "__esModule", { value: true });
let toExport = {};

import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/storage';
const TimeUtils = require('./TimeUtils');
const ImageUtils = require('./ImageUtils');

/*


  let updateList = [];
  updateList.push({...data, id:'adfjhsdjf'})

  databaseUtils.databaseSliceUpdate(firebase.firestore().collection(this.resource), updateList);

 */


toExport.databaseSliceUpdate = async function(ref, updatesAll, slice=100, time=0) {
  if(!slice) {
    slice = 100;
  }
  if(!time) {
    time = 0;
  }
  if(!Array.isArray(updatesAll)) {
    console.error('sliceUpdate need array on first parameter');
    return Promise.reject(new Error('sliceUpdate need array on first parameter'));
  }
  let batch = firebase.firestore().batch();

  let iAtual = 0;
  let iLocal = 0;
  let hasError = false;
  for(iAtual=0;iAtual<updatesAll.length;iAtual++) {
    let id = updatesAll[iAtual].id;
    let value = _.cloneDeep(updatesAll[iAtual]);
    delete value.id;
    batch.set(ref.doc(id), value, {merge:true});
    if(iLocal>=slice) {
      iLocal = 0;

      try {
        console.log('Commit parcial', iAtual);
        await batch.commit();
        if(time) {
          await TimeUtils.delay(time);
        }
        //   console.log('Commit end', iAtual);
      }catch(error) {
        hasError = true;
        console.error('Error, await batch.commit();', error);
      }
      batch = firebase.firestore().batch();
    }
    else {
      iLocal++;
    }
  }
  try {
    console.log('Commit final', iAtual);
    await batch.commit();
  }catch(error) {
    hasError = true;
    console.error('Error, await batch.commit();', error);
  }


  if(hasError) {
    return Promise.reject(new Error('Error, await batch.commit();'));
  }
  return 'ok';
};

toExport.uploadFile = function(path, file, progressFn, setUploadTask) {
  return new Promise(function (resolve, reject) {
    let storageRef = firebase.storage().ref(path);
    let uploadTask = storageRef.put(file);

    if(setUploadTask) {
      setUploadTask(uploadTask);
    }

    uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
      function (snapshot) {
        if (progressFn) {
          let progress = (snapshot.bytesTransferred / (snapshot.totalBytes ||1));
          progressFn(progress, snapshot.bytesTransferred, snapshot.totalBytes);
        }
      }, function (error) {
        reject(error);
      }, function () {
        uploadTask.snapshot.ref.getDownloadURL().then(function(url){
          progressFn(1);
          resolve(url);
        });
      });
  });
};
/*
StringFormat: 'raw' | 'base64' | 'base64url' | 'data_url'

 */

toExport.uploadString = function(path, file, progressFn, setUploadTask=undefined, StringFormat= 'data_url', contentType=undefined) {
  return new Promise(function (resolve, reject) {
    let storageRef = firebase.storage().ref(path);
    let uploadTask = null;
    if(contentType) {
      uploadTask = storageRef.putString(file, StringFormat, {
        contentType: contentType,
      });
    }
    else {
      uploadTask = storageRef.putString(file, StringFormat);
    }
    if(setUploadTask) {
      setUploadTask(uploadTask);
    }
    uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
      function (snapshot) {
        if (progressFn) {
          let progress = (snapshot.bytesTransferred / snapshot.totalBytes);
          progressFn(progress, snapshot.bytesTransferred, snapshot.totalBytes);
        }
      }, function (error) {
        reject(error);
      }, function () {
        uploadTask.snapshot.ref.getDownloadURL().then(function(url){
          progressFn(1);
          resolve(url);
        });
      });
  });
};

toExport.removeFile = function(path) {
  return new Promise(function (resolve, reject) {

    let storageRef = firebase.storage().ref(path);
    if(storageRef) {
      return storageRef.delete().then(function(){
        resolve();
      });
    }
    else {
      resolve();
    }
  });
};


class MyUploadAdapter {
  constructor( loader, fcmId = undefined, fcmType=undefined ) {
    // The file loader instance to use during the upload.
    this.loader = loader;
    this.isAbort = false;
    this.uploadTask = null;
    this.fcmId = fcmId;
    this.fcmType = fcmType;
  }

  // loader.uploadTotal = evt.total;
  // loader.uploaded = evt.loaded;

  // Starts the upload process.
  async upload() {
    this.isAbort = false;
    this.uploadTask = null;
    try {
      const file = await this.loader.file;
      const id = firebase.firestore().collection('ckeditorImages').doc().id;
    //  console.log('Teste', file);
    //  const blob = await ImageUtils.compactImageFromFile(file,'image/jpeg', 0.76, 3000, 3000);
      const compact = await ImageUtils.compactImageFromFile(file);
      if(!compact.isOk) {
        console.error('Error on compact image', compact);
        return new Error('Error on compact image');
      }
      const path = 'ckeditorImages/'+id+'.jpeg';
      const url = await toExport.uploadFile(
        path,
        compact.blob,
        (progress, transferred, total)=>{
          this.loader.uploadTotal = total;
          this.loader.uploaded = transferred;
        },
        (uploadTask)=>{
          this.uploadTask = uploadTask;
        });

      if(this.isAbort) {
        return new Error('Abort');
      }
      await firebase.firestore().collection('ckeditorImages').doc(id).set({
        url: url,
        resourceId: this.fcmId || null,
        resourceType: this.fcmType || null,
        path: path,
        createdAt: firebase.firestore.FieldValue.serverTimestamp(),
      }, {merge: true});

      return {default: url};
    } catch(err) {
      console.error('Erro no upload de imagem', err);
      return new Error('Error');
    }
  }

  // Aborts the upload process.
  async abort(teste) {
    this.isAbort = true;
    if(this.uploadTask) {
      this.uploadTask.cancel();
    }
  }
}


toExport.fcmUploadAdapterPlugin = function(editor) {
  editor.plugins.get( 'FileRepository' ).createUploadAdapter = ( loader ) => {
    // Configure the URL to the upload script in your back-end here!
    return new MyUploadAdapter( loader, editor.config?._config?.fcmId, editor.config?._config?.fcmType );
  };
};




export default toExport;

/*


exports.default = exports;
if(typeof module!=='undefined') {
  module.exports = exports;
}
*/
